import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getDevices = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/devices?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token,
            notCachedResponse: true
        }
    });
